// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bap_a","InstagramEmbed__mask":"bap_b bhh_bi bhh_bo bhh_wx"};